/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import ChargesDetails from "../../components/ChargesDetails/ChargesDetails";
import {
  fetchChargesDetails,
  fetchServiceByAggIdForChargeDetails,
} from "../../store/slices/charges";
import { fetchAgreementByAgrId, fetchGetAgreementsByAccId } from "../../store/slices/agreements";
import { fetchRateType } from "../../store/slices/rtkDictionaries";
import { fetchAccountById } from "../../store/slices/accounts";
import { checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

const ChargesDetailsContainer = () => {
  const { chargesDetails, chargesDetailsLoading } = useSelector((state) => state.charges);
  const { account, accountLoading } = useSelector((state) => state.accounts);

  const dispatch = useDispatch();
  const { chargeId } = useParams();

  const accountId = chargesDetails && chargesDetails?.resultSearchChargeByTransactionID?.accountId;

  const agreementId =
    chargesDetails && chargesDetails?.resultSearchChargeByTransactionID?.agreementId;

  useEffect(() => {
    if (accountId) dispatch(fetchGetAgreementsByAccId({ accId: accountId }));
    if (accountId) {
      if (!checkIsLoaded(accountLoading) || accountId !== account.id)
        dispatch(fetchAccountById({ id: accountId }));
    }
  }, [accountId]);

  useEffect(() => {
    if (agreementId) {
      dispatch(fetchAgreementByAgrId({ agreementId }));
      dispatch(
        fetchServiceByAggIdForChargeDetails({
          agreements: agreementId,
          includePastDates: false,
        })
      );
    }
  }, [agreementId]);

  useEffect(() => {
    dispatch(fetchRateType());
    dispatch(fetchChargesDetails({ chargeId }));
    return () => {};
  }, []);

  return (
    <div className="container_height">
      <ChargesDetails
        chargesDetails={chargesDetails}
        chargesDetailsLoading={chargesDetailsLoading}
      />
    </div>
  );
};

export default ChargesDetailsContainer;
